import React from "react";
import { message } from "antd";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import PhoneNumberInput from "components/ui/AppPhoneNumberInput";
import { authRoutesUrls } from "Layouts/AuthLayout/PublicRoutes";
import AppButton from "components/ui/AppButton";
import { API } from "api";
import AuthLayout from "../layout";
import { validatePhoneNumberWithoutPromise } from "../utils/helpers";

const ForgotPassword = () => {
  const { t } = useTranslation();
  const router = useHistory();
  const [phone, setPhone] = React.useState({ value: null, error: null });
  const [loading, setLoading] = React.useState(false);

  const handlePhoneChange = (key, value) => {
    const error = validatePhoneNumberWithoutPromise(value, t);
    setPhone({ value: value, error: error });
  };

  const handleSubmit = async () => {
    message.destroy();
    setLoading(true);
    let phoneNumber = phone?.value;
    if (phoneNumber?.length >= 0 && phoneNumber?.charAt(4) === "0") {
      phoneNumber = phoneNumber?.slice(0, 4) + phoneNumber?.slice(5);
    }
    const result = await API.FORGOT_PASSWORD({
      phoneNumber: phoneNumber,
    });
    if (result?.success === 1) {
      message.success(
        t(result?.message ?? "Code Sent to your email, Please check your email")
      );

      router.push({
        pathname: authRoutesUrls.newPassword,
        state: {
          phoneNumber: phoneNumber,
        },
      });
    } else {
      setPhone({ value: phoneNumber, error: t(result.error) });
      message.error(t(result.error));
    }
    setLoading(false);
  };

  return (
    <AuthLayout
      loading={loading}
      title={t("Forgot Password?")}
      description={t("Please enter your mobile number")}
    >
      <div className="flex-1 flex flex-col gap-8 justify-between h-full my-4 py-2">
        <div className="flex-1 flex items-center w-full h-full">
          <PhoneNumberInput
            label={t("Mobile Number")}
            value={phone.value}
            error={phone.error}
            keyVal="phone"
            inputProps={{
              autoComplete: "new-password",
              placeholder: t("123456789"),
              countryCallingCodeEditable: true,
              defaultCountry: "",
              countries: [],
              style: {
                height: "56px",
              }
            }}
            handleValues={handlePhoneChange}

          />
        </div>
        <AppButton
          type="submit"
          disabled={phone.error || !phone.value}
          className="w-full"
          onClick={handleSubmit}
        >
          {t("Submit")}
        </AppButton>
      </div>
    </AuthLayout>
  );
};

export default ForgotPassword;
